import { use } from 'react';
import { AppDataContext, HydrationStage } from '@/lib/app-data-hydration';

export function useHydrationStage() {
    const context = use(AppDataContext);
    const hydrationStage = context?.hydrationStage ?? HydrationStage.Initial;

    return {
        hydrationStage,
        isRendering: hydrationStage >= HydrationStage.Rendering,
        isSearchReady: hydrationStage >= HydrationStage.SearchReady,
        isFull: hydrationStage >= HydrationStage.Full,
        isUpdateAvailable: context?.isUpdateAvailable ?? false,
    };
}
